import { useEffect, useMemo } from 'react';
import { useRegisterChatPageContext } from '@trinity/chat-components/components/Chat/hooks/useRegisterPageContext.js';
import { ChatContextType } from '@/enums';
import type { BrandInsightsPageContext } from '@/types';
// import {
//   useRegisterChatPageContext,
//   type BrandInsightsPageContext,
//   ChatContextType,
// } from '@/brand-insights';

export const useRegisterGlobalChatContext = () => {
  const globalContext: BrandInsightsPageContext.Global = useMemo(() => ({
    type: ChatContextType.Global,
  }), []);

  const register = useRegisterChatPageContext();
  useEffect(() => {
    register(globalContext);
  }, [register, globalContext]);
};